import { render, staticRenderFns } from "./ReqAwsQuestionnaire.vue?vue&type=template&id=218a861a&scoped=true&"
import script from "./ReqAwsQuestionnaire.vue?vue&type=script&lang=js&"
export * from "./ReqAwsQuestionnaire.vue?vue&type=script&lang=js&"
import style0 from "./ReqAwsQuestionnaire.vue?vue&type=style&index=0&id=218a861a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "218a861a",
  null
  
)

export default component.exports